<template>
    <div class="d-flex">
        <div class="input-group my-0 mx-0 px-0 py-0">
            <button
            type="button"
            @click="showFlag = true"
            class="btn btn-light btn-sm px-0 py-0 my-0 mx-0"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
            :disabled="contact.loadingPhone"
            >
            <span class="input-group-text px-1 py-0">
                <img :src="flagActually" class="flag ml-0 mr-2" />
                + {{ country_id.phone_code }}
            </span>
            </button>
            <div class="dropdown-menu dropdown-menu-left">
            <button
                v-for="(country, i) of countriesFiltered.filter(
                (e) => e.visible
                )"
                class="dropdown-item"
                type="button"
                @click="changeCountry(country.id)"
                :key="i"
            >
                <img :src="flag2(country.id)" class="flag2" />
                <span class="ml-2 small"
                >+ {{ country.phone_code }} {{ country.name }}</span
                >
            </button>
            <div class="col-12 px-4 py-2">
                <span>Other country</span>
                <input
                class="my-1 border"
                placeholder="Your country..."
                type="text"
                v-model="filterCountry"
                />
            </div>
            </div>
            <input
            :disabled="contact.loadingPhone"
            id="phone"
            type="tel"
            class="form-control ml-2 px-1"
            v-model="phoneNumber"
            @input="validPhone"
            required="true"
            />
        </div>       
        <button
            v-if="phoneNumber"            
            class="rounded-3 ml-1 mt-0 mb-0 border-0 px-2 bg-primary text-white"
            @click="savePhoneContact(phoneNumber)"
        >
            <small>
            <i class="icon-plus"></i>
            </small>            
        </button>
    </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: 'InputPhoneWithCode',
  props: {
    contact: {
        type: Object,
        required: true,
    }
  },
  data() {
    return {
        phoneNumber: null,
        showFlag: true,
        optionsDefault: ["CA", "ES", "IT", "GB", "US", "FR", "DE"],
        flagActually: null,
        filterCountry: null,
        showFlag: true,
        countriesFiltered: [],
        countries: [],
        country_id: {
            id: "73",
            name: "France",
            iso: "fr",
            phone_code: "33",
            visible: true,
        },
    };
  },
  computed: {
    ...mapState({
      Countries: (state) => state.optionsList.all["profile_countries"].data,
    }),

    flag() {
      const flag = this.flags.find((el) => el.id === this.language_id).text;
      return require("@/assets/images/flags/" + flag);
    },
    flag2() {
      return (countryId) => {
        const flag = this.countries.find((el) => el.id === countryId).iso;
        return require("@/assets/images/flags/" + flag + ".svg");
      };
    },
  },
  watch: {
    filterCountry(newValue) {
      this.countriesFiltered = this.countries.map((e) => ({ ...e }));
      if (newValue.length > 2) {
        this.countriesFiltered = this.countriesFiltered.filter((e) =>
          e.name.toUpperCase().includes(newValue.toUpperCase())
        );
        this.countriesFiltered.forEach((e) => (e.visible = true));
      }
    },
    country_id(newValue, oldValue) {
      if (newValue.id === "3333") {
        this.flagActually = null;
        return;
      }

      //if(newValue.id != "3333"){
      const flag = this.countries.find((el) => el.id === newValue.id).iso;
      this.flagActually = require("@/assets/images/flags/" + flag + ".svg");
      this.showFlag = true;
      //}
    }   
  },
  methods: {
    
    savePhoneContact(phoneNumber) {
        const updatePhone = {
            id: this.contact.id,
            newPhone: '+' + this.country_id.phone_code + phoneNumber
        }

        this.$emit('savePhoneContact', updatePhone)
        this.phoneNumber = null      
    },

    validPhone() {      
      // Reemplaza caracteres no numéricos ni guion
      this.phoneNumber = this.phoneNumber.replace(/[^0-9-]/g, "");

      // Limita a 9 caracteres
      if (this.phoneNumber.length > 9) {
        this.phoneNumber = this.phoneNumber.slice(0, 9);
      }
    },

    changeCountry(countryId) {
      this.country_id = this.countries.find((e) => e.id === countryId);
    },

    countryDefault() {
      const flag = this.countries.find((el) => el.id == 73).iso;
      this.flagActually = require("@/assets/images/flags/" + flag + ".svg");
    },
  },
  created() {
    this.$store.dispatch("optionsList/getProfileCountries").then(() => {
      this.countries = this.Countries.map((el) => {
        return {
          ...el,
          iso: el.iso.toLowerCase(),
          visible: this.optionsDefault.includes(el.iso) ? true : false,
        };
      });
      this.countriesFiltered = this.countries;
      this.countryDefault();
    });
  },
};
</script>

<style scoped>
    .flag {
    width: 25px;
    }

    .flag2 {
    width: 12px;
    }
</style>